import React, { Component } from 'react';
import {toast } from 'react-toastify';
import cookie from 'react-cookies';
import $ from 'jquery';
import {updateValueInJson, esUrl, showModalPageClass, hideModalPageClass} from '../../../../../functions';
import axios from 'axios';
import {API_URL} from '../../../../../constants';
import ModalMultimedia from '../../../../Partials/ModalMultimedia';

export default class AdmBanner extends Component {

    constructor(props) {

        super(props); 

        this.state = { 
            modulo: this.props.modulo,
            tituloLongitud:0,
            bajadaLongitud:0,
            extractoLongitud:0,
            resource:{
                pmod_Id:0,
                pagi_Id:this.props.pagina,
                Mweb_Id:this.props.modulo.id,
                mban_Titulo:"",
                mban_Bajada:"",
                mban_Extracto:"",
                mban_ImagenPortada:"",
                mban_ImagenPortadaMovil:"",
                mban_Enlace:"",
                mban_EnlaceInternoExterno:false,
                mban_CapaOscura:false,
                mban_Orden:0,
                mban_Activo:true
            },
            resourceEdit:{
                mban_Id:0,
                mban_Titulo:"",
                mban_Bajada:"",
                mban_Extracto:"",
                mban_ImagenPortada:"",
                mban_ImagenPortadaMovil:"",
                mban_Enlace:"",
                mban_EnlaceInternoExterno:false,
                mban_CapaOscura:false,
                mban_Orden:0,
                mban_Activo:true
            },
            Validacion: {
                mban_Titulo: {
                    Error: false,                    
                },
                mban_Orden: {
                    Error: false,                    
                },
                mban_Enlace: {
                    Error: false,                    
                }
            },
            ValidacionEdit:{
                mban_Titulo: {
                    Error: false,                    
                },
                mban_Orden: {
                    Error: false,                    
                },
                mban_Enlace: {
                    Error: false,                    
                }
            },
            banners:[],
            hasError:false,
            added:false,
            confirmStore:false,
            security: cookie.load('user'),
            roles: [], 
            fieldReturnMultimedia:""
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeEdit = this.handleInputChangeEdit.bind(this);
        this.getResponseMultimedia = this.getResponseMultimedia.bind(this);
    }

    getResponseMultimedia = (urlSeleccionada) => {
        let resource = this.state.isEditfieldReturnMultimedia ? this.state.resourceEdit : this.state.resource;
        let fieldReturn = this.state.fieldReturnMultimedia;
    
        if(fieldReturn!== ""){
    
            resource[fieldReturn] = urlSeleccionada;
            
            if(this.state.isEditfieldReturnMultimedia){
                this.setState({resourceEdit:resource, fieldReturnMultimedia:"", isEditfieldReturnMultimedia:false});
            }else{
                this.setState({resource:resource, fieldReturnMultimedia:""});
            }
        }
    
        hideModalPageClass("divGestorArchivosBanner");
    }
    
    showModalMultimedia = (clase = "", campo = "", isEdition = false) => {
        this.setState({fieldReturnMultimedia:campo, isEditfieldReturnMultimedia:isEdition});
        showModalPageClass(clase);
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let tituloLongitud = this.state.tituloLongitud;
        let bajadaLongitud = this.state.bajadaLongitud;
        let extractoLongitud = this.state.extractoLongitud;

        let validaciones = this.state.Validacion;

        validaciones[target.name] = {
            Error: false,                    
        }

        if(target.name == 'mban_Titulo'){
            tituloLongitud = value.length;
        }
        if(target.name == 'mban_Bajada'){
            bajadaLongitud = value.length;
        }
        if(target.name == 'mban_Extracto'){
            extractoLongitud = value.length;
        }
        this.setState({
            resource: copyResource,
            tituloLongitud: tituloLongitud,
            bajadaLongitud: bajadaLongitud,
            extractoLongitud: extractoLongitud,
            Validacion: validaciones
        });  
    }

    handleInputChangeEdit(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resourceEdit;
        copyResource[target.name] = value;

        let tituloLongitud = this.state.tituloLongitud;
        let bajadaLongitud = this.state.bajadaLongitud;
        let extractoLongitud = this.state.extractoLongitud;

        let validaciones = this.state.ValidacionEdit;

        validaciones[target.name] = {
            Error: false,                    
        }

        if(target.name == 'mban_Titulo'){
            tituloLongitud = value.length;
        }
        if(target.name == 'mban_Bajada'){
            bajadaLongitud = value.length;
        }
        if(target.name == 'mban_Extracto'){
            extractoLongitud = value.length;
        }
        this.setState({
            resourceEdit: copyResource,
            tituloLongitud: tituloLongitud,
            bajadaLongitud: bajadaLongitud,
            extractoLongitud: extractoLongitud,
            ValidacionEdit: validaciones
        });  
    }

    showAgregarBanner = (e) => {

        e.preventDefault();

        $(".containerFormCreation").fadeIn();  
        $("#btnGuardarBanner").fadeIn();
        $("#btnAgregarBanner").fadeOut();
    }

    hideAgregarBanner = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        $(".containerFormCreation").fadeOut();  
        $("#btnGuardarBanner").fadeOut();
        $("#btnAgregarBanner").fadeIn();
    }

    checkedValidate = (item, isEdition = false) => {

        if(isEdition)
        {
            let resource = this.state.resourceEdit;
            resource[item] = !resource[item];
    
            this.setState({resourceEdit:resource});
        }else{
            let resource = this.state.resource;
            resource[item] = !resource[item];

            this.setState({resource:resource});
        }
        
    }

    storeBanner = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.mban_Titulo == '') {              
            newState.Validacion.mban_Titulo = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mban_Orden == '') {  
            newState.Validacion.mban_Orden = {Error: true};
            newState.hasError = true;
        }

        if (newState.resource.mban_Enlace !== '' && !esUrl(newState.resource.mban_Enlace)) {  
            newState.Validacion.mban_Enlace = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ModuloBannerUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'mban_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                let result = data.data.result;
                let stateResponse = this.state;

                stateResponse.added = true;
                stateResponse.resource.mban_Titulo = '';
                stateResponse.resource.mban_Bajada = '';
                stateResponse.resource.mban_Extracto = '';
                stateResponse.resource.mban_ImagenPortada = '';
                stateResponse.resource.mban_ImagenPortadaMovil = '';
                stateResponse.resource.mban_Enlace = '';
                stateResponse.resource.mban_EnlaceInternoExterno = false;
                stateResponse.resource.mban_CapaOscura = false;
                stateResponse.resource.mban_Orden += 1;
                stateResponse.resource.pmod_Id = result.pmod_Id;

                this.setState(stateResponse);
                this.loadBanners();
                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 
                
                this.hideAgregarBanner();

            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    updateBanner = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resourceEdit.mban_Titulo == '') {              
            newState.ValidacionEdit.mban_Titulo = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mban_Orden == '') {  
            newState.ValidacionEdit.mban_Orden = {Error: true};
            newState.hasError = true;
        }

        if (newState.resourceEdit.mban_Enlace !== '' && !esUrl(newState.resourceEdit.mban_Enlace)) {  
            newState.ValidacionEdit.mban_Enlace = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ModuloBannerUX/`;
        var dataForm = this.state.resourceEdit;
        dataForm = updateValueInJson(dataForm,'mban_UsuarioEdicion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.put(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                this.setState({resourceEdit: {
                    mban_Id:0,
                    mban_Titulo:"",
                    mban_Bajada:"",
                    mban_Extracto:"",
                    mban_ImagenPortada:"",
                    mban_ImagenPortadaMovil:"",
                    mban_Enlace:"",
                    mban_EnlaceInternoExterno:false,
                    mban_CapaOscura:false,
                    mban_Orden:0,
                    mban_Activo:true
                }});
                this.loadBanners();
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    loadBanners = () => {

        let pmod_Id = this.state.resource.pmod_Id;

        const url = `${API_URL}ModuloBannerUX/${pmod_Id}`;

        axios.get(url).then(response => response.data)
        .then((data) => {
            let resourceBanner = this.state.resource;
            resourceBanner.mban_Orden = data.result.length + 1;
            this.setState({ banners: data.result, resource: resourceBanner});
        })
        .catch(error => {
            console.log('Error de comunicación');   
        });
    }

    actualizarEstado = (entity, e) => {

        e.preventDefault();

        const url = `${API_URL}ModuloBannerUX/`;
        entity.mban_Activo = !entity.mban_Activo;
        let dataToSave=updateValueInJson(entity, 'mban_UsuarioEdicion', this.state.security.nUsuCodigo);
        const formData = JSON.stringify(dataToSave);

        axios.put(
            url, 
            JSON.stringify(formData),
            { headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
                }
            }
            ).then(
                (data)=> {     
                    if (data.data.isSucess)
                    {
                        this.loadBanners();
                        return;
                    } else 
                    {                        
                        console.log('No se pudo procesar la solicitud \r');
                    }
                    this.setState({loading:false});
                }
            ).catch((error)=> {
                console.log('Error no controlado.');
                this.setState({loading:false});
            });  
    }

    eliminarRegistro = async(entity, e) => {
        e.preventDefault();
        const url = `${API_URL}ModuloBannerUX/Eliminar`;

        let dataToSave=updateValueInJson(entity, 'mban_UsuarioEliminacion', this.state.security.nUsuCodigo);
        const formData = JSON.stringify(dataToSave);

        await axios.put(
            url, 
            JSON.stringify(formData),
            { headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
                }
            }
            ).then(
                (data)=> {     
                    if (data.data.isSucess)
                    {
                        this.loadBanners();
                        return;
                    } else 
                    {
                        this.setState({loading:false});
                        console.log('No se pudo procesar la solicitud \r');
                    }
                }
            ).catch((error)=> {
                console.log('Error no controlado.');
                this.setState({loading:false});
            });  
    }

    editRegistro = (entity, e) => {

        e.preventDefault();
        let newEntity = entity;
        this.setState({resourceEdit: newEntity});
    }

    closeBanner = () => {

        let resource = this.state.resource;
        resource.pmod_Id = 0;
        this.setState({resource:resource, banners:[]});

        this.props.callback(true);
        
    }

    cancelarEdicionBanner = () => {
        
        this.setState({
            resourceEdit:{
                mban_Id:0,
                mban_Titulo:"",
                mban_Bajada:"",
                mban_Extracto:"",
                mban_ImagenPortada:"",
                mban_ImagenPortadaMovil:"",
                mban_Enlace:"",
                mban_EnlaceInternoExterno:false,
                mban_CapaOscura:false,
                mban_Orden:0,
                mban_Activo:true
            }
        });
    }

    componentWillReceiveProps(nextProps){

        let mweb = 1;

        if(nextProps.pmodId !== this.state.resource.pmod_Id && mweb == nextProps.mWebEdit){
            let resource = this.state.resource;
            resource.pmod_Id = nextProps.pmodId;

            this.setState({resource: resource});

            setTimeout(() => { 
                this.loadBanners();
            }, 100); 
        }
      } 

    render() {

        let modulo = this.state.modulo;

        return (
            <div className="divModalBanner popUpGeneral" id={"modal_" + modulo.id} style={{display:"none"}}>
                <div className="divLayerPopup_ModalPaginas">
                    <div className="divPopup_ModalPaginas">
                    <div className="divClosePopup_Modals" onClick={() => this.closeBanner()}/>
                    <h2>{modulo.nombre} </h2>
                    <div className="divWrapperModalPaginas">
                        {
                            this.state.banners.length > 0 ?
                            <div className="divModuloPopup_Panel">
                                {
                                    this.state.banners.map((banner) => (
                                        <React.Fragment>
                                        <div className="txtFile x-1">
                                            <input type="text" readOnly placeholder="Submenu" value={banner.mban_Titulo}/>
                                            <div className="divBtnAccionesPopup_Panel">
                                                <a href="#" className={banner.mban_Activo ? "btnPageModuloVer noneEvent" : "btnPageModuloInactivo noneEvent"} onClick={(e) => this.actualizarEstado(banner, e)}/>                       
                                                <a href="#" className="btnPageModuloEditar noneEvent" onClick={(e) => this.editRegistro(banner, e)}/>
												
                                                
												
												<a href className="btnPageModuloEliminar aEliminarMenu2"/>
												<div className="c_divAlertaCapa">
													<div className="divAlertaCapa">
														<div className="divAlerta">
															<h2>&iquest;Seguro de eliminar?</h2>
															<div className="divAlertaBtn">
																<a href="#" className="btnAlertaAceptar" onClick={(event) => this.eliminarRegistro(banner, event)}>ACEPTAR</a>
																<a href="#" className="btnAlertaCancelar">CANCELAR</a>
															</div>
														</div>
													</div>
												</div>
												
												
                                            </div>
                                        </div>
                                        {
                                            this.state.resourceEdit.mban_Id == banner.mban_Id ?
                                            <div className="containerFormEdit divModuloPopup_Panel">
                                                <div className="txtFile x-1">
                                                    <input type="text" placeholder="Título linea 1" name='mban_Titulo' value={this.state.resourceEdit.mban_Titulo} maxLength={45} className={this.state.ValidacionEdit.mban_Titulo.Error ? "error" : ""}  
                                                    onChange={this.handleInputChangeEdit}/>
                                                    <span data-length={45}>{this.state.tituloLongitud}/45</span>
                                                </div>
                                                <div className="txtFile x-1">
                                                    <input type="text" placeholder="Título linea 2 (texto será más grande)" name='mban_Bajada' value={this.state.resourceEdit.mban_Bajada} maxLength={45}  
                                                    onChange={this.handleInputChangeEdit}/>
                                                    <span data-length={45}>{this.state.bajadaLongitud}/45</span>
                                                </div>
                                                <div className="txtFile x-1">
                                                    <input type="text" placeholder="Bajada del Banner" name='mban_Extracto' value={this.state.resourceEdit.mban_Extracto} maxLength={150}  
                                                    onChange={this.handleInputChangeEdit}/>
                                                    <span data-length={150}>{this.state.extractoLongitud}/150</span>
                                                </div>
                                                <div className="txtFile x-1 relative">
                                                    <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosBanner", "mban_ImagenPortada", true)}/>
                                                    <input type="text" placeholder="Imagen Portada" name='mban_ImagenPortada' value={this.state.resourceEdit.mban_ImagenPortada} 
                                                    onChange={this.handleInputChangeEdit}/>
													<label className="recomendacion">Se recomienda la dimensión de 1920px de ancho X 600px de alto.</label>
                                                </div>
                                                <div className="txtFile x-1 relative">
                                                    <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosBanner", "mban_ImagenPortadaMovil", true)}/>
                                                    <input type="text" placeholder="Imagen Portada Movil" name='mban_ImagenPortadaMovil' value={this.state.resourceEdit.mban_ImagenPortadaMovil} 
                                                    onChange={this.handleInputChangeEdit}/>
													<label className="recomendacion">Se recomienda la dimensión de 400px de ancho X 480px de alto.</label>
                                                </div>
                                                <div className="txtFile x-1">
                                                    <input type="text" placeholder="Enlace" name='mban_Enlace' value={this.state.resourceEdit.mban_Enlace} 
                                                    className={this.state.ValidacionEdit.mban_Enlace.Error ? "error" : ""} 
                                                    onChange={this.handleInputChangeEdit}/>
                                                </div>

                                                <div className="divWrapperActive">
                                                    <div>
                                                        <span>Enlace <br />externo?</span>
                                                    </div>	
                                                    
                                                    <div>	
                                                        <div className={this.state.resourceEdit.mban_EnlaceInternoExterno ? "containerActive backgroundPosition" : "containerActive"}
                                                        onClick={() => this.checkedValidate("mban_EnlaceInternoExterno", true)}>
                                                            <div className={this.state.resourceEdit.mban_EnlaceInternoExterno ? "actionActive leftPosition" : "actionActive"}/>
                                                        </div>
                                                        <span>{this.state.resourceEdit.mban_EnlaceInternoExterno ? "Activado" : "Desactivado"}</span>  
                                                    </div>

                                                    <div>						
                                                        <span>Capa <br />Oscura </span> 
                                                    </div>

                                                    <div>	
                                                        <div className={this.state.resourceEdit.mban_CapaOscura ? "containerActive backgroundPosition" : "containerActive"}
                                                        onClick={() => this.checkedValidate("mban_CapaOscura", true)}>
                                                            <div className={this.state.resourceEdit.mban_CapaOscura ? "actionActive leftPosition" : "actionActive"}/>
                                                        </div>
                                                        <span>{this.state.resourceEdit.mban_CapaOscura ? "Activado" : "Desactivado"}</span>  
                                                    </div>

                                                </div>


                                                <div className="txtFile x-2">
                                                    <input type="text" placeholder="Orden" name='mban_Orden' value={this.state.resourceEdit.mban_Orden} maxLength={2} className={this.state.ValidacionEdit.mban_Orden.Error ? "error" : ""} onChange={this.handleInputChangeEdit}/>
                                                </div>
                                                <div className="clear"></div>
                                                <div className="txtFile x-2">
                                                    <a href="" className="btnAgregarPagina" id="btnActualizarBanner" onClick={(e) => this.updateBanner(e)}>ACTUALIZAR</a>
                                                    <a href="" className="btnAgregarPagina noneEvent" id="btnCancelarActualizarBanner" onClick={() => this.cancelarEdicionBanner()}>CANCELAR</a>
                                                </div>
                                                
                                            </div>
                                            : null
                                        }
                                        </React.Fragment>
                                    ))
                                }
                            </div> : null
                        }
                        
                        

                        <div className="containerFormCreation divModuloPopup_Panel" style={{display:"none"}}>
                            <div className="txtFile x-1">
                                <input type="text" placeholder="Título linea 1" name='mban_Titulo' value={this.state.resource.mban_Titulo} maxLength={45} className={this.state.Validacion.mban_Titulo.Error ? "error" : ""}  
                                onChange={this.handleInputChange}/>
                                <span data-length={45}>{this.state.tituloLongitud}/45</span>
                            </div>
                            <div className="txtFile x-1">
                                <input type="text" placeholder="Título linea 2 (texto será más grande)" name='mban_Bajada' value={this.state.resource.mban_Bajada} maxLength={45}  
                                onChange={this.handleInputChange}/>
                                <span data-length={45}>{this.state.bajadaLongitud}/45</span>
                            </div>
                            <div className="txtFile x-1">
                                <input type="text" placeholder="Bajada del Banner" name='mban_Extracto' value={this.state.resource.mban_Extracto} maxLength={150}  
                                onChange={this.handleInputChange}/>
                                <span data-length={150}>{this.state.extractoLongitud}/150</span>
                            </div>
                            <div className="txtFile x-1 relative">
                                <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosBanner", "mban_ImagenPortada")}/>
                                <input type="text" placeholder="Imagen Portada" name='mban_ImagenPortada' value={this.state.resource.mban_ImagenPortada} 
                                onChange={this.handleInputChange}/>
								<label className="recomendacion">Se recomienda la dimensión de 1920px de ancho X 600px de alto.</label>
                            </div>
                            <div className="txtFile x-1 relative">
                                <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosBanner", "mban_ImagenPortadaMovil")}/>
                                <input type="text" placeholder="Imagen Portada Movil" name='mban_ImagenPortadaMovil' value={this.state.resource.mban_ImagenPortadaMovil} 
                                onChange={this.handleInputChange}/>
								<label className="recomendacion">Se recomienda la dimensión de 400px de ancho X 480px de alto.</label>
                            </div>
                            <div className="txtFile x-1">
                                <input type="text" placeholder="Enlace" name='mban_Enlace' value={this.state.resource.mban_Enlace} 
                                className={this.state.Validacion.mban_Enlace.Error ? "error" : ""} 
                                onChange={this.handleInputChange}/>
                            </div>
                            
                            <div className="divWrapperActive">
                                <div>
                                    <span>Enlace <br />externo?</span>
                                </div>	
                                
                                <div>	
                                    <div className={this.state.resource.mban_EnlaceInternoExterno ? "containerActive backgroundPosition" : "containerActive"}
                                    onClick={() => this.checkedValidate("mban_EnlaceInternoExterno")}>
                                        <div className={this.state.resource.mban_EnlaceInternoExterno ? "actionActive leftPosition" : "actionActive"}/>
                                    </div>
                                    <span>{this.state.resource.mban_EnlaceInternoExterno ? "Activado" : "Desactivado"}</span>  
                                </div>

                                <div>						
                                    <span>Capa <br />Oscura </span> 
                                </div>

                                <div>	
                                    <div className={this.state.resource.mban_CapaOscura ? "containerActive backgroundPosition" : "containerActive"}
                                    onClick={() => this.checkedValidate("mban_CapaOscura")}>
                                        <div className={this.state.resource.mban_CapaOscura ? "actionActive leftPosition" : "actionActive"}/>
                                    </div>
                                    <span>{this.state.resource.mban_CapaOscura ? "Activado" : "Desactivado"}</span>  
                                </div>

                            </div>


                            <div className="txtFile x-2">
                                <input type="text" placeholder="Orden" name='mban_Orden' value={this.state.resource.mban_Orden} maxLength={2} className={this.state.Validacion.mban_Orden.Error ? "error" : ""} onChange={this.handleInputChange}/>
                            </div>
                        </div>

                        

                        
                        
                        <div>
                            <a href="" className="btnAgregarPagina" id="btnAgregarBanner" onClick={(e) => this.showAgregarBanner(e)}>AGREGAR</a>
                            <a href="" style={{display:"none"}} className="btnAgregarPagina" id="btnGuardarBanner" onClick={(e) => this.storeBanner(e)}>GUARDAR</a>
                            <br/>
                            <br/>
                            <br/>
                        </div>

                    </div>
                    </div>
                </div>
                <ModalMultimedia class="divGestorArchivosBanner" callback={this.getResponseMultimedia.bind(this)}/>
            </div>
        )
    }
}
